import {chain} from "../../utils/fs";
import {sortMulti} from "../../utils/collections";
import { cs } from "../../react/chain-services";
import {UseState} from "../../react/use-state";
import {SearchableSelect} from "./searchable-select";
import {Load} from "../../react/load";
import {consumeContext} from "../../react/context";

export const officeSearch = (textField, idBranch) => cs(
    consumeContext("apis"),
    ["state", ({}, next) => UseState({
        defaultValue: {
            type: "none",
            value: {
                branchId: idBranch
            },
        },
        next,
    })],
    ["branchList", ({apis}, next) => Load({
        fetch: () => apis.next.getBranchList({filterByUserLevel: false}),
        next,
    })],

    ({state, branchList, apis})=>{
        return SearchableSelect({
            list: chain(
                branchList || [],
                (_) => sortMulti(_, [
                    (branch) => branch["branchName"]?.toLowerCase(),
                ]),
            ),
            placeholder: "Please select an office",

            getLabel: (branch) => branch.branchName + ` (${branch.idBranch})`,
            onSelect: async (branch) => {
                if (!branch) {
                    state.onChange({
                        type: "none",
                        value: branch && {
                            branchId: ''
                        },
                    });
                    textField.onChange('');
                } else {
                    state.onChange({
                        type: "none",
                        value: branch && {
                            branchId: branch.idBranch
                        },
                    });
                    let branchInfo = await apis.next.getBranchById(branch.idBranch);
                    textField.onChange(JSON.stringify({...branchInfo}));
                }
            },
            isSelected: (branch) => state.value?.value?.branchId === branch.idBranch,

            searchLabel: "Search an Office",
            xdQaName: "SELECT AN OFFICE",
            id: textField.id,
        })
    }
);
